import React, { createContext, useState, useContext } from "react";

export const SearchFilterContext = createContext();

export const SearchFilterProvider = ({ children }) => {
  const [openFilterDropdownId, setOpenFilterDropdownId] = useState(null);
  const [priceMin, setPriceMin] = useState("");
  const [priceMax, setPriceMax] = useState("");
  const [surfaceMin, setSurfaceMin] = useState("");
  const [surfaceMax, setSurfaceMax] = useState("");
  const [roomMin, setRoomMin] = useState("");
  const [roomMax, setRoomMax] = useState("");
  const [bedroomMin, setBedroomMin] = useState("");
  const [bedroomMax, setBedroomMax] = useState("");
  const [numberOfBathrooms, setNumberOfBathrooms] = useState("");
  const [typeOfFloor, setTypeOfFloor] = useState([]);
  const [sortBy, setSortBy] = useState({
    label: "Più recenti",
    value: "most_recent",
  });
  const [openSearchMobileFilterDialog, setOpenSearchMobileFilterDialog] =
    useState(false);
  const [
    isHousePriceCalculatorDialogOpen,
    setIsHousePriceCalculatorDialogOpen,
  ] = useState(null);

  const toggleSearchMobileFilterDialog = () => {
    setOpenSearchMobileFilterDialog(!openSearchMobileFilterDialog);
  };

  const toggleFilterDropdown = (id) => {
    setOpenFilterDropdownId(openFilterDropdownId === id ? null : id);
  };

  const toggleHousePriceCalculatorDialog = (id) => {
    setIsHousePriceCalculatorDialogOpen(
      isHousePriceCalculatorDialogOpen === id ? null : id
    );
  };

  return (
    <SearchFilterContext.Provider
      value={{
        openFilterDropdownId,
        toggleFilterDropdown,
        priceMin,
        setPriceMin,
        priceMax,
        setPriceMax,
        surfaceMin,
        setSurfaceMin,
        surfaceMax,
        setSurfaceMax,
        roomMin,
        setRoomMin,
        roomMax,
        setRoomMax,
        bedroomMin,
        setBedroomMin,
        bedroomMax,
        setBedroomMax,
        numberOfBathrooms,
        setNumberOfBathrooms,
        typeOfFloor,
        setTypeOfFloor,
        sortBy,
        setSortBy,
        openSearchMobileFilterDialog,
        toggleSearchMobileFilterDialog,
        isHousePriceCalculatorDialogOpen,
        toggleHousePriceCalculatorDialog,
      }}
    >
      {children}
    </SearchFilterContext.Provider>
  );
};
